import gql from 'graphql-tag';

export const ORGANIZATION_CHART_DATA =gql`
query me($okr_Duedate_Range: [DateTime],$createdBy: ID,$employee: ID,$offset:Int,$first: Int){
    OrganizationChartData:me{
        id
        employee {
          id
          organizationSet {
            totalCount
            edgeCount
            edges {
              node {
                id
                ceo {
                  id
                  okrContributorSet(savedOkrType: "OBJECTIVE", role:"OWNER", employee:$employee,createdBy:$createdBy,okr_Duedate_Range:$okr_Duedate_Range,orderBy: ["okr__duedate"],offset:$offset,first:$first) {
                    edges {
                        node {
                          id
                          okrType
                          progress
                          requestStatus
                          okr {
                            id
                            title
                            duedate
                            isDiscarded {
                              id
                            }
                            discardRequest(status:"PENDING") {
                              edges {
                                node {
                                  id
                                  status
                                }
                              }
                            }
                            contributorSet {
                              edges {
                                node {
                                  id
                                  employee {
                                    id
                                    user{
                                      id
                                    }
                                  }
                                  requestStatus
                                }
                              }
                            }
                          }
                        }
                    }
                  }
                }
              }
            }
          }
        }
      }
}
`